import { render, staticRenderFns } from "./ProgramView.vue?vue&type=template&id=94725f42&scoped=true"
import script from "./ProgramView.vue?vue&type=script&lang=js"
export * from "./ProgramView.vue?vue&type=script&lang=js"
import style0 from "./ProgramView.vue?vue&type=style&index=0&id=94725f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94725f42",
  null
  
)

export default component.exports